import { useMatch } from 'react-router-dom'
import { CustomBreadCrumbConfig } from 'components/Breadcrumbs'
import { PathNames } from 'constants/General'

const reviewBreadcrumbs: CustomBreadCrumbConfig[] = [
  {
    title: 'massPayouts.massPayouts',
    link: `${PathNames.MASS_PAYOUTS}`,
  },
  {
    title: 'massPayouts.payoutDetails',
  },
]

/**
 * The MFE serves both mass-payouts pages under one `/*` route. The review page keeps legacy's
 * custom breadcrumbs; the landing page returns `undefined` so it keeps the path-based default.
 */
export const useMassPayoutsPageBreadcrumbs = (): CustomBreadCrumbConfig[] | undefined => {
  const isReviewRoute = !!useMatch(`${PathNames.MASS_PAYOUTS}${PathNames.MASS_PAYOUTS_REVIEW}`)

  return isReviewRoute ? reviewBreadcrumbs : undefined
}
